import React from 'react';
import { COMPANY_CONFIG } from '../config/constants';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t mt-auto" style={{borderColor: '#e0e0e0'}}>
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_hr-farm-stack/artifacts/ihlas732_Zobox-New-Logo.png" 
              alt="ZOBOX" 
              className="h-8 w-auto mb-4"
            />
            <p className="text-sm italic mb-4" style={{color: '#546e7a'}}>
              {COMPANY_CONFIG.tagline}
            </p>
            
            {/* Contact Info */}
            <div className="text-sm space-y-2" style={{color: '#546e7a'}}>
              <p className="flex items-center">
                <span className="mr-2">📞</span> {COMPANY_CONFIG.phone}
              </p>
              <p className="flex items-center">
                <span className="mr-2">✉️</span> {COMPANY_CONFIG.email}
              </p>
              <p className="flex items-center">
                <span className="mr-2">🌐</span> {COMPANY_CONFIG.website}
              </p>
            </div>
          </div>

          {/* Corporate Branch */}
          <div>
            <h3 className="font-semibold mb-3" style={{color: '#2b3380'}}>
              📍 {COMPANY_CONFIG.branches[0].name}
            </h3>
            <div className="text-sm space-y-1 mb-3" style={{color: '#546e7a'}}>
              {COMPANY_CONFIG.branches[0].address.map((line, idx) => (
                <p key={idx}>{line}</p>
              ))}
            </div>
            <a 
              href={COMPANY_CONFIG.branches[0].mapUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium inline-flex items-center hover:underline"
              style={{color: '#2b3380'}}
            >
              <span className="mr-1">🗺️</span> View on Map
            </a>
          </div>

          {/* Registered Office */}
          <div>
            <h3 className="font-semibold mb-3" style={{color: '#2b3380'}}>
              📍 {COMPANY_CONFIG.branches[1].name}
            </h3>
            <div className="text-sm space-y-1 mb-3" style={{color: '#546e7a'}}>
              {COMPANY_CONFIG.branches[1].address.map((line, idx) => (
                <p key={idx}>{line}</p>
              ))}
            </div>
            <a 
              href={COMPANY_CONFIG.branches[1].mapUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium inline-flex items-center hover:underline"
              style={{color: '#2b3380'}}
            >
              <span className="mr-1">🗺️</span> View on Map
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-3" style={{color: '#2b3380'}}>Quick Links</h3>
            <div className="text-sm space-y-2" style={{color: '#546e7a'}}>
              <p>
                <a href="/employees" className="hover:underline" style={{color: '#546e7a'}}>Employees</a>
              </p>
              <p>
                <a href="/attendance" className="hover:underline" style={{color: '#546e7a'}}>Attendance</a>
              </p>
              <p>
                <a href="/leaves" className="hover:underline" style={{color: '#546e7a'}}>Leave Management</a>
              </p>
              <p>
                <a href="/payroll" className="hover:underline" style={{color: '#546e7a'}}>Payroll</a>
              </p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-6 border-t text-center text-sm" style={{borderColor: '#e0e0e0', color: '#546e7a'}}>
          <p>© {currentYear} {COMPANY_CONFIG.name}. All rights reserved.</p>
          <p className="mt-1 text-xs">Designed & Developed for Human Resource Management</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
